import { render, staticRenderFns } from "./TrainingDownloadsSide.vue?vue&type=template&id=43d4806d&scoped=true&"
import script from "./TrainingDownloadsSide.vue?vue&type=script&lang=js&"
export * from "./TrainingDownloadsSide.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDownloadsSide.vue?vue&type=style&index=0&id=43d4806d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4806d",
  null
  
)

export default component.exports